<template>
    <div class="marketing-rules-box">
        <a-alert :message="$t('goods.marketing_rules' /* 限购规则：应用于某些场景下，某些客户对指定门票的购买资格或购买数量的制约。*/)" type="info" show-icon class="top-alert" />

        <a-input-search
            :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('goods.rule_name' /* 规则名称 */)"
            class="mt20 name-search"
            style="width: 400px"
            allowClear
            enter-button
            @search="onSearch"
        />
        <div class="mt20 mb10">
            <a-button type="primary" icon="plus" @click="handleAdd()">{{ $t('web.add' /* 添加 */) }}</a-button>
        </div>

        <s-table ref="table" size="default" :rowKey="record => record.id" :columns="columns" :data="loadData" :scroll="{ x: 800 }">
            <!--  序号 -->
            <span slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
            </span>

            <!--  规则名称 -->
            <span slot="name" slot-scope="text, record">
                <a-button @click="handleShowInfoData(record)" type="link">{{ text }}</a-button>
            </span>

            <!--  实行状态 -->
            <span slot="status" slot-scope="text, record">
                <!--                <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />-->
                <a-switch @change="handleChangeStatus(record)" :checked="record.status == 1" :checked-children="$t('web.open' /* 开启 */)" :un-checked-children="$t('web.close' /* 关闭 */)" />
            </span>

            <!--  操作 -->
            <span slot="action" slot-scope="text, record">
                <a @click="handleShowInfoData(record)">{{ $t('web.edit' /* 编辑 */) }}</a>
                <a-divider type="vertical" />
                <a @click="handleDelete(record)" class="del-button">{{ $t('web.delete' /* 删除 */) }}</a>
            </span>
        </s-table>

        <market-edit :visible="visible" @cancel="handleCancel" :data-info="dataInfo" @ok="handleOk" />
    </div>
</template>

<script>
import MarketEdit from '@/views/goods-module/components/market-edit.vue';
import STable from '@/components/Table';

const statusTypeFilter = {
    0: 'error',
    1: 'processing'
};
const statusFilter = {
    0: '已关闭',
    1: '进行中'
};
export default {
    name: 'MarketingRules',
    data() {
        return {
            visible: false,
            components: {
                STable
            },
            // 加载数据方法 必须为 Promise 对象
            loadData: parameter => {
                let data = {
                    page: parameter.page,
                    limit: parameter.limit
                };
                this._queryTitle && (data.name = this._queryTitle);
                return this.$request.get({ url: 'saleLimitList', data }).then(res => {
                    return res.data;
                });
            },
            dataInfo: {}, // 编辑时的数据
            columns: [
                {
                    title: this.$t('goods.index' /* 序号 */),
                    align: 'center',
                    scopedSlots: { customRender: 'index' },
                    fixed: 'left'
                },
                {
                    title: this.$t('goods.rule_name' /* 规则名称 */),
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                    align: 'center',
                    fixed: 'left'
                },
                {
                    title: this.$t('goods.doing_status' /* 实行状态 */),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    title: this.$t('goods.start_time' /* 开始时间 */),
                    dataIndex: 'start_time',
                    align: 'center'
                },
                {
                    title: this.$t('goods.end_time' /* 结束时间 */),
                    dataIndex: 'end_time',
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right'
                }
            ]
        };
    },
    components: {
        MarketEdit,
        STable
    },
    created() {},
    filters: {
        statusTypeFilter(value) {
            return statusTypeFilter[value];
        },
        statusFilter(value) {
            return statusFilter[value];
        }
    },
    methods: {
        onSearch(value) {
            this._queryTitle = value;
            this.$refs.table.refresh();
        },
        handleAdd() {
            this.visible = true;
        },
        handleOk() {
            this.dataInfo = {};
            this.visible = false;
            this.$refs.table.refresh();
        },
        handleCancel() {
            this.dataInfo = {};
            this.visible = false;
        },
        handleShowInfoData(record) {
            let data = JSON.parse(JSON.stringify(record)); // 深拷贝
            data.condition && (data.condition = JSON.parse(data.condition));
            data.event && (data.event = JSON.parse(data.event));
            this.dataInfo = data;
            this.visible = true;
        },
        handleChangeStatus(record) {
            let data = {
                ids: record.id,
                type: record.status == 1 ? 0 : 1
            };
            this.$request.post({ url: 'setSaleLimitStatus', data }).then(res => {
                this.$message.success(this.$t('web.operate_scuuess' /* 操作成功 */));
                this.$refs.table.refresh();
            });
        },
        handleDelete(record) {
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('web.confirm_delete_data' /* 确定删除该条数据吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    this.$request.post({ url: 'setSaleLimitStatus', data: { ids: record.id, type: -1 } }).then(res => {
                        this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                        this.$refs.table.refresh();
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
    .name-search {
        width: 100% !important;
    }
    .top-alert {
        word-break: normal;
        overflow-wrap: break-word;
    }
}
</style>
